<template>
  <div>
    <div class="breadcrumb-wrap">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-custom">
        <el-breadcrumb-item>权限管理</el-breadcrumb-item>
        <el-breadcrumb-item>角色管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-dialog :visible.sync="addVisible" title="新增角色" @close="close('addRoleForm')">
        <el-form :model="addRoleObj" status-icon :rules="rules" label-width="80px" ref="addRoleForm" class="ruleForm">
            <el-form-item label="资源名称" prop="roleName">
                <el-input class="margin-space" placeholder="请输角色名称" v-model="addRoleObj.roleName">
                </el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remarks">
                <el-input class="margin-space" placeholder="请输入备注" v-model="addRoleObj.remarks">
                </el-input>
            </el-form-item>
            <div style="text-align: right" class="margin-space">
                <el-button :loading="addLoading" type="primary" @click="addConfirmClick('addRoleForm')">
                    提交
                </el-button>
            </div>
        </el-form>
    </el-dialog>
    <el-button v-if="myResources.indexOf('/admin/role/create') !== -1" type="primary" @click="addRoleClick" size="small" class="margin-space">新增角色</el-button>
    <LoadingNoDialog :loading="loading">

      <el-table
        v-if="myResources.indexOf('/admin/role/list') !== -1"
        border
        :data="tableData"
        style="width: 100%">
        <el-table-column
          type="index"
          width="50">
        </el-table-column>
        <el-table-column
          prop="roleName"
          label="角色名称"
        >
        </el-table-column>
        <el-table-column
          prop="remarks"
          label="备注"
        >
        </el-table-column>
        <el-table-column
          prop="sysCode"
          label="所属系统"
        >
        </el-table-column>
        <el-table-column
          prop="createdAt"
          label="创建时间">
        </el-table-column>
        <el-table-column
          prop="s"
          label='分配资源'
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="success"
              v-if="myResources.indexOf('/admin/role-to-resource') !== -1"
              plain
              size="mini"
              @click="setResource(scope.$index, scope.row)">分配
            </el-button>
            <el-button
              type="danger"
              v-if="myResources.indexOf('/admin/role/delete') !== -1"
              plain
              :loading="loadArr[scope.$index]"
              size="mini"
              @click="deleteRole(scope.$index, scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 10px;text-align: right">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10,20, 50, 100, 500,1000]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

    </LoadingNoDialog>
    <ResourceSelect ref="ResourceSelect" @sure="resouceSure"/>
  </div>
</template>

<script>
  import LoadingNoDialog from '../../components/LoadingNoDialog.vue'
  import axios from 'axios'
  import ResourceSelect from './components/ResourceSelect.vue'

  const moment = require('moment')

  export default {
    name: 'Role',
    data() {
      return {
        addVisible: false,
        tableData: [],
        loading: true,
        addLoading: false,
        loadArr: [],
        page: 1,
        size: 10,
        total: 0,
        addRoleObj: {
          roleName: '',
          remarks: ''
        },
        rules:{
            roleName:[
                {required:true,message:'资源名称不能为空',trigger:'blur'}
            ]
        },
        myResources:[]
      }
    },
    components: {
      LoadingNoDialog,
      ResourceSelect
    },
    mounted() {
      this.getList()
    },
    methods: {
      async getList() {
        this.loading = true
        let r = await axios.get('/admin/role/list', {params: {page: this.page, size: this.size}})
        this.tableData = r.data.rows.map(item => Object.assign(item, {createdAt: moment(item.createdAt).format('YYYY/MM/DD HH:mm:ss')}))
        this.loadArr = [];
        for(let i=0; i<r.data.count; i++){
            this.loadArr.push(false);
        }
        this.total = r.data.count
        this.getMyResources();
        this.loading = false
      },
      async getMyResources() {
        let r = await axios.get('/admin/my-resources');
        this.myResources = r.data.map(item => item.apiUrl);
      },
      handleSizeChange(val) {
        this.size = val
        this.getList()
      },
      setResource(index,row){
        this.$refs.ResourceSelect.setVisible(row)
      },
      handleCurrentChange(val) {
        this.page = val
        this.getList()
      },
      addRoleClick(){
        this.addVisible=true
      },
      addConfirmClick(formName) {
        this.$refs[formName].validate(async valid => {
            if(valid){
                this.addLoading=true
                let r = await axios.post('/admin/role/create', this.addRoleObj)
                if(r.code == 0){
                    this.$message.success('新增成功');
                }
                this.$refs[formName].resetFields();
                this.addLoading=false
                this.addVisible=false
                this.getList()
            }
        })
      },
      deleteRole(index,row){
        this.loadArr[index] = true;
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
            let r = await axios.delete('/admin/role/delete',{
                params:{
                    id:row.id
                }
            })
            if(r.code == 0){
                this.$message.success('删除成功');
            }
            this.getList();
            this.loadArr[index] = false;
        }).catch(() => {
          this.loadArr[index] = false;
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      close(formName){
        this.$refs[formName].resetFields();
      },
      resouceSure(){
        this.getList()
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/main/permission/Role.vue